import { getSecureAccountsApi, putAccountsApi, getMainApi, putMainApi, postSecureAccountsApi, postMainApi, deleteMainApi, deleteAccountsApi, putFile, putFileAccounts } from "@Shared/utils/ajax";
export const getEmailPreferences = async () => {
  const endpoint = "/notification/preferences";
  return getSecureAccountsApi({}, endpoint);
};
export const updateEmailPreferences = async preferences => {
  const endpoint = "/notification/preferences";
  return putAccountsApi(preferences, endpoint);
};
export const updateAccountPreferences = async tutorial => {
  const endpoint = "/preferences";
  return putAccountsApi({
    tutorial
  }, endpoint);
};
export const updateDomain = async subdomain => {
  const endpoint = "/customize/subdomain";
  return putAccountsApi({
    subdomain
  }, endpoint);
};
export const changePassword = async (currentPassword, newPassword, email) => {
  const endpoint = "/change-password";
  return postSecureAccountsApi({
    email,
    currentPassword,
    newPassword
  }, endpoint);
};
export const getFilogixDetails = async () => {
  const endpoint = "/filogix";
  return getMainApi({}, endpoint);
};
export const updateFilogixDetails = async details => {
  const endpoint = "/filogix";
  return putMainApi(details, endpoint);
};
export const getSyncedEmails = async () => {
  return getSecureAccountsApi({}, "/email/sync");
};
export const validateSyncedEmail = async code => {
  return putAccountsApi({
    code,
    redirectUri: `${window.location.origin}/nylas-callback`
  }, "/email/sync");
};
export const getBrokerageOverrides = async () => {
  const endpoint = "/brokerage/customize/overrides";
  return getMainApi({}, endpoint);
};
export const updateBrokerageOverrides = async overrides => {
  const endpoint = "/brokerage/customize/overrides";
  return putMainApi(overrides, endpoint);
};
export const getBrokerageData = async () => {
  const endpoint = "/brokerage/customize";
  return getMainApi({}, endpoint);
};
export const updateBrokerageData = async (defaultBrokerageAgent, subdomain, firmLicenseId) => {
  const endpoint = "/brokerage/customize";
  const data = {
    defaultBrokerageAgent,
    subdomain,
    firmLicenseId
  };
  return putMainApi(data, endpoint);
};
export const getBrokerageBoards = async () => {
  const endpoint = "/brokerage/customize/boards";
  return getMainApi({}, endpoint);
};
export const updateBrokerageBoards = async (displayFrench, statuses) => {
  const endpoint = "/brokerage/customize/boards";
  const data = {
    displayFrench,
    statuses
  };
  return putMainApi(data, endpoint);
};
export const updateBrokerageLogo = async () => {
  return postMainApi({}, "/brokerage/customize/logo");
};
export const removeBrokerageLogo = async () => {
  return deleteMainApi("/brokerage/customize/logo");
};
export const removePersonalLogo = async () => {
  return deleteAccountsApi("/customize/logo");
};
export const getSignedURL = async (fileName, settingsType) => {
  const brokerage = "/brokerage/customize/logo/signed-s3-url";
  const personal = "/customize/logo/signed-s3-url";
  if (settingsType === "brokerage-settings") return getMainApi({
    fileName
  }, brokerage);
  return getSecureAccountsApi({
    fileName
  }, personal);
};
export const updatePersonalStyles = async file => {
  return putFileAccounts(file, "/customize/stylesheet");
};
export const updateBrokerageStyles = async file => {
  return putFile(file, "/brokerage/customize/stylesheet");
};
export const getPersonalFaq = async () => {
  return getSecureAccountsApi({}, "/customize/faq");
};
export const getBrokerageFaq = async () => {
  return getMainApi({}, "/brokerage/customize/faq");
};
export const updateBrokerageFaq = async faq => {
  return putMainApi(faq, "/brokerage/customize/faq");
};
export const updatePersonalFaq = async faq => {
  return putAccountsApi(faq, "/customize/faq");
};
export const getSyncedCalendars = async () => {
  return getSecureAccountsApi({}, `/calendar/list`);
};
export const renewTokenNylas = async grantId => {
  return getSecureAccountsApi({}, `/grantId/${grantId}`);
};
export const updateRefreshToken = async (grantId, refreshToken) => {
  return putAccountsApi({
    refreshToken
  }, `/grantId/${grantId}`);
};
export const removeSyncedEmail = async accountId => {
  return deleteAccountsApi(`/email/${accountId}`);
};
export const toggleCalendarSync = async (accountId, calendarId, name, description, readOnly) => {
  const endpointCalendarId = calendarId.replace(/#/g, "");
  return postSecureAccountsApi({
    accountId,
    name,
    description,
    readOnly,
    calendarId
  }, `/calendar/${endpointCalendarId}/toggle-sync`);
};
export const updateDefaultEmail = async accountId => {
  return putAccountsApi({
    nylasAccountId: accountId
  }, `/email/update-default`);
};
export const pullFilogixDetailsFromExpert = async () => {
  return getMainApi({}, "/filogix/import/user");
};
export const verifyExpertProfileNumber = async code => {
  return postMainApi({
    code
  }, "/filogix/verify");
};